"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_jss_1 = require("react-jss");
exports.jss = react_jss_1.jss;
const jss_plugin_rule_value_function_1 = __importDefault(require("jss-plugin-rule-value-function"));
const jss_plugin_global_1 = __importDefault(require("jss-plugin-global"));
const jss_plugin_nested_1 = __importDefault(require("jss-plugin-nested"));
const jss_plugin_camel_case_1 = __importDefault(require("jss-plugin-camel-case"));
const jss_plugin_vendor_prefixer_1 = __importDefault(require("jss-plugin-vendor-prefixer"));
const jss_plugin_props_sort_1 = __importDefault(require("jss-plugin-props-sort"));
let DOMONDA_UI_JSS_INSTALLED = false;
// Sets up the JSS instance by injecting necessary plugins.
function install() {
    if (DOMONDA_UI_JSS_INSTALLED) {
        return;
    }
    DOMONDA_UI_JSS_INSTALLED = true;
    react_jss_1.jss.setup({
        createGenerateId: process.env.NODE_ENV === 'production'
            ? () => {
                let ruleCounter = 0;
                return (_0, sheet) => {
                    ruleCounter += 1;
                    let jssId = '';
                    if (sheet) {
                        // id can indeed exist (copied from the official JSS repo)
                        if (sheet.options.jss.id != null) {
                            jssId = String(sheet.options.jss.id);
                        }
                    }
                    return `c${jssId}${ruleCounter}`;
                };
            }
            : undefined,
        plugins: [jss_plugin_rule_value_function_1.default(), jss_plugin_global_1.default(), jss_plugin_nested_1.default(), jss_plugin_camel_case_1.default(), jss_plugin_vendor_prefixer_1.default(), jss_plugin_props_sort_1.default()],
    });
}
exports.install = install;
